import { useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap"
import { Helmet } from "react-helmet";

const AdminPage = () => {
    const [activeTab, setActiveTab] = useState<string>("dashboard");

    function handleTabClick(e: any) {
        setActiveTab(e.target.value);
    }

    return (<>
        <Helmet>
            <title>Darknet Games | Admin</title>
        </Helmet>
        <Container>
            <Row>
                <Col>
                    <Card className="card-widget" id="admin-widget">
                        <Card.Header>
                            <Card.Title>Admin Panel</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col xs={1} className="text-center">
                                    <ul id="admin-menu">
                                        <li>
                                            <button className="dg-btn dg-btn-link" onClick={handleTabClick} value="dashboard">Dashboard</button>
                                        </li>
                                        <li>
                                            <button className="dg-btn dg-btn-link" onClick={handleTabClick} value="accounts">Accounts</button>
                                        </li>
                                        <li>
                                            <button className="dg-btn dg-btn-link" onClick={handleTabClick} value="games">Games</button>
                                        </li>
                                    </ul>
                                </Col>
                                <Col className="admin-content bl-1">
                                    <div id="dashboard" className={activeTab === "dashboard" ? "d-block" : "d-none"}>
                                        <h5>Dashboard</h5>
                                    </div>
                                    <div id="accounts" className={activeTab === "accounts" ? "d-block" : "d-none"}>
                                        <h5>Accounts</h5>
                                    </div>
                                    <div id="games" className={activeTab === "games" ? "d-block" : "d-none"}>
                                        <h5>Games</h5>
                                        <table className="table table-hover text-light">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Title</th>
                                                    <th>Developer</th>
                                                    <th>Genre</th>
                                                    <th>Release Date</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Game 1</td>
                                                    <td>Developer 1</td>
                                                    <td>Genre 1</td>
                                                    <td>2021-01-01</td>
                                                    <td>
                                                        <button className="dg-btn dg-btn-primary">Edit</button>
                                                        <button className="dg-btn dg-btn-danger">Delete</button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>2</td>
                                                    <td>Game 2</td>
                                                    <td>Developer 2</td>
                                                    <td>Genre 2</td>
                                                    <td>2021-01-01</td>
                                                    <td>
                                                        <button className="dg-btn dg-btn-link">Edit</button>
                                                        <button className="dg-btn dg-btn-link">Delete</button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>3</td>
                                                    <td>Game 3</td>
                                                    <td>Developer 3</td>
                                                    <td>Genre 3</td>
                                                    <td>2021-01-01</td>
                                                    <td>
                                                        <button className="dg-btn dg-btn-link">Edit</button>
                                                        <button className="dg-btn dg-btn-link">Delete</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>);
}

export default AdminPage;